// ViewBannerModal.tsx

import React from "react";
import { Modal, Text, Button, Group, TextInput } from "@mantine/core";
import { IconPhoto } from "@tabler/icons-react";
import classes from "./view.module.css"; // Use appropriate styles
import { RowDataBannerWeb } from "./types";

interface ViewBannerModalProps {
  isOpen: boolean;
  onClose: () => void;
  bannerData: RowDataBannerWeb;
}

const ViewBannerModal: React.FC<ViewBannerModalProps> = ({
  isOpen,
  onClose,
  bannerData,
}) => {
  return (
    <Modal
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          View Banner
        </div>
      }
      opened={isOpen}
      onClose={onClose}
    >
      <TextInput label="Title:" mb="sm" value={bannerData.title} disabled />

      <Text className={classes.Text}>
        Image <span className={classes.format}>(.jpg, .png)</span>
      </Text>
      <div className={classes.bannerImageContainer}>
        {bannerData.img ? (
          <img
            src={bannerData.img}
            alt="Banner Image"
            className={classes.bannerImageSize}
          />
        ) : (
          <p>
            <IconPhoto />
          </p>
        )}
      </div>

      <TextInput label="Banner Type:" mb="sm" value={bannerData.type || ''} disabled />

      <TextInput label="Route:" value={bannerData.route ? bannerData.route : ''} disabled />

      {/* <Group className={classes.buttonBottom}>
        <Button onClick={onClose} className={classes.buttonClose}>
          Close
        </Button>
      </Group> */}
    </Modal>
  );
};

export default ViewBannerModal;
